export default class AlertCookies {

	static selector = 'alert-cookies';

	// class variables

	el = {};

	flags = {
		isPlaying: false
	};

	promises = {
		videoPlay: null
	};

	states = {
		activeItem: null
	};

	// constructor

	constructor(container) {
		this.el = {
			container,
			ctaAccept: container.querySelector(`.${this.constructor.selector}__cta-accept`),
			ctaDecline: container.querySelector(`.${this.constructor.selector}__cta-decline`),
		};

		this.initialize();
	}

	// initialize

	initialize() {
		this.#addEventListeners();
	}

	// add / remove event listeners

	#addEventListeners = () => {
		this.el.ctaAccept.addEventListener('click', this.#onCtaAcceptClick);
		this.el.ctaDecline.addEventListener('click', this.#onCtaDeclineClick);
	}

	#removeEventListeners = () => {
		this.el.ctaAccept.removeEventListener('click', this.#onCtaAcceptClick);
		this.el.ctaDecline.removeEventListener('click', this.#onCtaDeclineClick);
	}

	// listener methods

	#onCtaAcceptClick = () => {
		this.close();
	}

	#onCtaDeclineClick = () => {
		this.close();
	}

	//

	close() {
		this.el.container.classList.add('is-closed');
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
